"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-extra-content-container" };
const _hoisted_2 = {
    key: 0,
    class: "little-green-men"
};
const _hoisted_3 = {
    key: 1,
    class: "mined-metal mined-steel"
};
const _hoisted_4 = {
    key: 2,
    class: "mined-metal mined-titanium"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.lifeFound())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isMiningTileOnSteel())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isMiningTileOnTitanium())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
